import html from "./Dashboard.html"
import "./Dashboard.css"
import "../Dashboard/ActionGroup.js"
import "../Dashboard/DrilldownModal.js"
import "../Dashboard/ParticipantInfoHeader.js"
import "../Dashboard/PatientEnteredNotes.js"
import "../Dashboard/ProfilePhoto.js"
import "../Dashboard/ProjectList.js"
import "../Dashboard/VerifyEmailAddress.js"
import "../Dashboard/WebVisualization.js"
import moment from 'moment-timezone';

var module = angular.module("ResearchKitApplicationModule");
module.component('dashboard', {
	template: html,
	bindings: {
		"dashboardKey": "<",
		"patientId": "<"
	},
	controller: 'dashboardController',
	controllerAs: 'vm'
});

module.controller("dashboardController", ["$scope", "$http", "ceUrl",
	function ($scope, $http, ceUrl) {
		var vm = this;

		vm.$onInit = function () {
			loadDashboard();
		};

		var recognizedComponentTypes = ["WebVisualization", "ParticipantInfoHeader", "StudyList", "VerifyEmailAddress", "ActionGroup", "PatientEnteredNotes"];
		var cleanDashboardModel = function (model) {
			var sections = [];
			for (var i = 0; i < model.Sections.length; i++) {
				var sectionComponents = [];
				for (var j = 0; j < model.Sections[i].Components.length; j++) {
					if (recognizedComponentTypes.indexOf(model.Sections[i].Components[j].Type) != -1) {
						sectionComponents.push(model.Sections[i].Components[j]);
					}
				}

				if (sectionComponents.length) {
					sections.push({
						Title: model.Sections[i].Title,
						Components: sectionComponents
					});
				}
			}
			return { Sections: sections };
		}

		function loadDashboard() {
			vm.loading = true;
			var url = "api/researchkit/studyparticipant/dashboard/" + vm.dashboardKey + "?offset=" + encodeURIComponent(moment().format("Z"));
			if (vm.patientId) {
				url = url + "&patientID=" + vm.patientId;
			}

			$http.get(ceUrl.make(url)).then(function (response) {
				vm.dashboardModel = cleanDashboardModel(response.data);
			}).finally(function () {
				vm.loading = false;
			});
		}

		$scope.$on("refreshDashboard", loadDashboard);
	}
]);